module.exports = __webpack_public_path__ + "imgs/stopwatch.f9d29dabec2e4e07247474f3f32c51e2.svg";